import { ApiRespCode } from './api';

type RequestDelayFunction = (attempt: number, error: Error | null, response: Response | null) => number;

export interface RequestInitWithRetry extends RequestInit {
    retries?: number;
    retryDelay?: number | RequestDelayFunction;
    log?: boolean;
}

const defaultOptions: RequestInitWithRetry = {
    retries: 3,
    retryDelay: 1000,
    log: false,
};

let pendingRequests = 0;
export const hasPendingRequests = (): boolean => pendingRequests > 0;

export const getFormattedParams = (params: Record<string, any>) => {
    let formattedParams = '';

    if (params) {
        const newParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                if (value.length > 0) {
                    // @ts-ignore
                    newParams.append(key, value);
                }
            } else if (value) {
                newParams.append(key, value);
            }
        });

        formattedParams = `?${newParams}`;
    }

    return formattedParams;
};

export const ttFetch = (
    options: Partial<RequestInitWithRetry> = {},
): ((url: string, input?: RequestInitWithRetry) => Promise<Response | JsonValue>) => {
    const { headers, keepalive, method, retries, retryDelay } = Object.assign({}, defaultOptions, options);

    return (url: string, input) => {
        const form = input.body instanceof FormData;

        input = {
            method,
            headers: Object.assign({}, headers, input.headers),
            body: form ? input.body : JSON.stringify(input.body),
            keepalive,
        };

        if (form) {
            delete input.headers['Content-Type'];
        }

        return new Promise((res, rej) => {
            const wrappedFetch = (attempt: number): void => {
                pendingRequests++;

                try {
                    fetch(url, input)
                        .then(async (response) => {
                            const r = response.clone();
                            let body = null;
                            let srvCode = null;
                            let status = null;

                            if (r.status === 302) {
                                window.location.href = r.headers.get('Location');
                            }

                            try {
                                body = await r.json();
                                srvCode = body?.code;
                                status = r?.status;
                            } catch (e) {
                                console.error(`Error on r.json() for endpoint "${url}" and input`, input, e);
                                try {
                                    console.error(
                                        'Error, but can response.text()',
                                        e,
                                        response.status,
                                        await response.text(),
                                    );
                                } catch (e1) {
                                    console.error('Error on response.text()', e, response.status, e1);
                                }
                                rej(new Error('ошибка ответа сервера'));
                            }

                            if (!r.ok) {
                                console.error(
                                    `Error on response.status for endpoint "${url}" and input`,
                                    input?.body,
                                    r.status,
                                    body,
                                );
                            }
                            if (
                                !response.ok &&
                                attempt < retries &&
                                srvCode !== null &&
                                srvCode !== ApiRespCode.ERR_ANSWERED_RESPONSE
                            ) {
                                retry(attempt, null, response);
                            } else {
                                res({
                                    status,
                                    url,
                                    ...body,
                                });
                            }
                        })
                        .catch((error) => {
                            if (attempt < retries) {
                                retry(attempt, error, null);
                            } else {
                                console.error(`Error in catch block for endpoint "${url}" and input`, error);
                                rej(new Error('ошибка сети'));
                            }
                        })
                        .finally(() => {
                            pendingRequests--;
                        });
                } catch (e) {}
            };

            function retry(attempt, error, response): void {
                const delay = typeof retryDelay === 'function' ? retryDelay(attempt, error, response) : retryDelay;
                setTimeout(function () {
                    wrappedFetch(++attempt);
                }, delay);
            }

            wrappedFetch(1);
        });
    };
};
